import storage from '../../helpers/storage';
import { authenticated } from '../../helpers/auth-header';
import insighttAPI from './insightt-api-client';
import { reportsEndpoints } from '../endpoints';

const STORAGE_KEY = 'insightt-logger';

/**
 * @deprecated
 * @param response
 */
export const cloudLogger = (response) => {
  try {
    let user = storage.get('user');
    if (user) user = JSON.parse(user);
    else user = {};

    const { email } = user;
    const env = response.config.baseURL?.includes('dev') ? 'dev' : 'prod';
    let logs = storage.get(STORAGE_KEY);
    if (!logs) logs = [];
    else logs = JSON.parse(logs);
    logs.push({
      env,
      email,
      url: response.config.url,
      status: response.status,
      data: response.data,
    });
    storage.set(STORAGE_KEY, JSON.stringify(logs));
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    // console.error(e);
  }
};

/**
 * @deprecated
 * @returns {Promise<void>}
 */
const pushLogs = async () => {
  try {
    let logs = storage.get(STORAGE_KEY);
    if (!logs) logs = [];
    else logs = JSON.parse(logs);
    if (logs.length > 0) {
      await authenticated(insighttAPI).post(reportsEndpoints.sendCloudLogs(), logs);
    }
    storage.remove(STORAGE_KEY);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    // console.error(e);
  }
};

setInterval(pushLogs, 1000 * 30); // 30 seconds
